"use strict"

function reservationTimestamp(item) {
  const time = String((item && item.times) || "00:00")
    .split(",")[0]
    .trim()
  const [hours = 0, minutes = 0] = time.split(":").map(Number)
  const timestamp = new Date(
    Number(item && item.year),
    Number(item && item.month) - 1,
    Number(item && item.day),
    hours,
    minutes
  ).getTime()
  return Number.isFinite(timestamp) ? timestamp : 0
}

// 메이커샷: 촬영일부터 이 날 수 동안 원본을 고른다.
const MAKERSHOT_ACCESS_DAYS = 7
// 프리미엄: 사진이 아직 안 올라온 예약을 '사진 준비 중'으로 보이는 날 수(촬영일부터).
// 원본 받는 기한(올린 날 + 14일)과 맞춘다. 7일이던 때 사진 받기를 처음 연 8월에 촬영 8~11일 뒤 올린 예약이
// 올라오기 전에 '기한종료'로 보였다(2026-10-14 확인, 9월부터는 모두 3일 안에 올라옴).
const PREMIUM_WAITING_DAYS = 14

function photoAccessDeadlineTimestamp(item, days = MAKERSHOT_ACCESS_DAYS) {
  const year = Number(item && item.year)
  const month = Number(item && item.month)
  const day = Number(item && item.day)
  const reservationDate = new Date(year, month - 1, day)

  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day) ||
    reservationDate.getFullYear() !== year ||
    reservationDate.getMonth() !== month - 1 ||
    reservationDate.getDate() !== day
  ) {
    return 0
  }

  return new Date(year, month - 1, day + days).getTime()
}

function isPhotoAccessExpired(item, now = Date.now(), days = MAKERSHOT_ACCESS_DAYS) {
  const deadline = photoAccessDeadlineTimestamp(item, days)
  return deadline > 0 && now >= deadline
}

function sortReservationsByProximity(items, now = Date.now()) {
  return [...(Array.isArray(items) ? items : [])].sort((left, right) => {
    const leftTimestamp = reservationTimestamp(left)
    const rightTimestamp = reservationTimestamp(right)
    const distanceDifference =
      Math.abs(leftTimestamp - now) - Math.abs(rightTimestamp - now)

    if (distanceDifference !== 0) return distanceDifference
    return rightTimestamp - leftTimestamp
  })
}

function isReservationUpcoming(item, now = Date.now()) {
  const timestamp = reservationTimestamp(item)
  return timestamp > 0 && timestamp > now
}

function findUpcomingReservation(items, now = Date.now(), isCanceled = () => false) {
  return (
    [...(Array.isArray(items) ? items : [])]
      .sort((left, right) => reservationTimestamp(left) - reservationTimestamp(right))
      .find((item) => !isCanceled(item) && isReservationUpcoming(item, now)) || null
  )
}

function conceptThumbnailUrl(value) {
  const image = String(value || "").trim()
  if (!image) return ""
  if (/^(?:https?:|data:|\/)/i.test(image)) return image
  return `/upload/concept/thumbnail_image/${image}`
}

function resolveReservationThumbnail({ item, concept, product, fallback }) {
  const conceptImage =
    concept &&
    (concept.pattern_1_image || concept.pattern1Image || concept.patternAImage)

  return (
    conceptThumbnailUrl(conceptImage) ||
    (item &&
      (item.conceptThumbnail ||
        item.concept_thumbnail ||
        item.thumbnail)) ||
    (product &&
      (product.thumbnail ||
        product.image ||
        product.mainImage ||
        product.main_image)) ||
    fallback ||
    ""
  )
}

function resolvePhotoAction({ item, serviceKey, now = Date.now() }) {
  const reservation = item || {}

  if (serviceKey === "makershot") {
    if (reservation.photoLookupStatus === "error") {
      return {
        disabled: true,
        labelKey: "button.photos-status-error",
        target: "none",
      }
    }
    if (isPhotoAccessExpired(reservation, now)) {
      return {
        disabled: true,
        labelKey: "page.mypage.shot-list.shot-image-select-date-over",
        target: "none",
      }
    }
    if (!reservation.hasMyShots) {
      if (!isReservationUpcoming(reservation, now)) {
        return {
          disabled: true,
          labelKey: "button.photos-preparing",
          target: "none",
        }
      }
      return {
        disabled: true,
        labelKey: "button.unvisited",
        target: "none",
      }
    }
    return {
      disabled: false,
      labelKey: "button.check-original",
      target: reservation.qrcodeId ? "makershot-original" : "none",
    }
  }

  if (!serviceKey) {
    return {
      disabled: true,
      labelKey: "button.photos-status-error",
      target: "none",
    }
  }

  if (reservation.photoDeliveryStatus === "published") {
    return {
      disabled: false,
      labelKey: "button.receive-photos",
      target: "premium-delivery",
    }
  }

  if (now < reservationTimestamp(reservation)) {
    return {
      disabled: true,
      labelKey: "button.unvisited",
      target: "none",
    }
  }

  if (isPhotoAccessExpired(reservation, now, PREMIUM_WAITING_DAYS)) {
    return {
      disabled: true,
      labelKey: "page.mypage.shot-list.shot-image-select-date-over",
      target: "none",
    }
  }

  return {
    disabled: true,
    labelKey: "button.photos-preparing",
    target: "none",
  }
}

function resolvePhotoRoute({ action, item }) {
  if (!action || !item) {
    return ""
  }
  if (action.target === "makershot-original" && item.qrcodeId) {
    return `/mypage/select?id=${item.qrcodeId}`
  }
  if (action.target === "premium-delivery" && item.reservation_id) {
    return `/mypage/photos/${item.reservation_id}`
  }
  return ""
}

module.exports = {
  conceptThumbnailUrl,
  findUpcomingReservation,
  isPhotoAccessExpired,
  isReservationUpcoming,
  photoAccessDeadlineTimestamp,
  reservationTimestamp,
  resolvePhotoAction,
  resolvePhotoRoute,
  resolveReservationThumbnail,
  sortReservationsByProximity,
}
